<template>
  <CartLogin v-if="!$store.state.user && !noLogin" v-on:continueNoLogin="continueNoLogin"/>
  <CardContainer class="mt-5" v-else>
    <template v-slot:title>
      {{ text.pages.cart.provideAddress }}
    </template>
    <template v-slot:content>

      <v-form ref="form" v-model="valid" lazy-validation @input="validate">
        <v-container>
          <v-row>
            <v-col cols="12" md="4" offset-md="2">
              <v-text-field
                class="text-uppercase"
                v-model="address.firstName"
                :rules="requiredAndLength"
                :counter="100"
                :label="text.fields.address.firstName"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                class="text-uppercase"
                v-model="address.lastName"
                :rules="requiredAndLength"
                :counter="100"
                :label="text.fields.address.lastName"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" offset-md="2">
              <v-text-field
                class="text-uppercase"
                v-model="address.email"
                :rules="emailRules"
                :label="text.fields.email"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                class="text-uppercase"
                v-model="address.phone"
                :rules="requiredAndLength"
                :label="text.fields.phone"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" offset-md="2">
              <v-text-field
                class="text-uppercase"
                v-model="address.address1"
                :rules="requiredAndLength"
                :counter="100"
                :label="text.fields.address.address1"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                class="text-uppercase"
                v-model="address.address2"
                :rules="lengthRules"
                :counter="100"
                :label="text.fields.address.address2"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" offset-md="2">
              <v-text-field
                class="text-uppercase"
                v-model="address.zip"
                :rules="requiredAndLength"
                :counter="100"
                :label="text.fields.address.zip"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                class="text-uppercase"
                v-model="address.city"
                :rules="requiredAndLength"
                :counter="100"
                :label="text.fields.address.city"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" offset-md="2"
                   v-if="$store.state.user"
            >
              <v-checkbox
                v-model="address.saveAsDefault"
                :label="text.fields.saveAsDefault"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" md="4"
                   :offset-md="$store.state.user ? 2 : 0"
            >
              <v-checkbox
                v-model="address.invoiceRequired"
                :label="text.fields.invoiceRequired"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row v-show="address.invoiceRequired">
            <v-col cols="12" md="4" offset-md="4">
              <v-text-field
                class="text-uppercase"
                v-model="address.nip"
                :rules="address.invoiceRequired ? nipValidator : []"
                :counter="100"
                :label="text.fields.nip"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" offset-md="3">
              <v-textarea
                v-model="address.invoiceData"
                name="input-7-4"
                :label="text.fields.invoiceData"
                :rules="address.invoiceRequired ? requiredRules : []"
                @click="valid"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </template>
    <template v-slot:action>
      <CartActionButtons
        :current-step="currentStep"
        :view-step="viewStep"
        v-on:back="$emit('back')"
        v-on:confirm="confirmAddress"
        :hide-confirm="!valid"
      />
    </template>
  </CardContainer>
</template>

<script>
import { translations } from '@/lang/translations';
import Axios from '@/core/Axios';
import CardContainer from '@/components/Partials/CardContainer.vue';
import CartActionButtons from '@/components/Pages/CartActionButtons.vue';
import CartLogin from '@/components/Pages/CartLogin.vue';
import { state } from '../../store/index';

export default {
  name: 'CartAddress',
  components: { CartLogin, CardContainer, CartActionButtons },
  props: ['currentStep'],
  data() {
    return {
      valid: false,
      noLogin: false,
      address: {
        firstName: null,
        lastName: null,
        address1: null,
        address2: null,
        zip: null,
        city: null,
        country: 'Polska',
        phone: null,
        email: null,
        invoiceRequired: false,
        nip: null,
        saveAsDefault: false,
        invoiceData: null,
      },
      axios: new Axios(),
      viewStep: 3,
    };
  },
  mounted() {
    this.validate();
    this.getCustomerAddress();
  },
  methods: {
    continueNoLogin() {
      this.noLogin = true;
    },
    confirmAddress() {
      this.$refs.form.validate();
      if (this.valid) {
        this.$emit('confirm');
        this.$store.commit('updateOrderData', { address: this.address });
      }
    },
    validate() {
      if (this.$refs.form) {
        this.$refs.form.validate();
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    getCustomerAddress() {
      if (!this.$store.state.user) {
        return false;
      }

      this.axios.makeCall('post', 'norbit/customer/getaddress', {
        uid: this.$store.state.user.uid,
      })
        .then((response) => {
          if (Object.keys(response).length > 0) {
            this.address = Object.assign(this.address, response);
            this.address.firstName = response.first_name;
            this.address.lastName = response.last_name;
            this.address.address1 = response.address_1;
            this.address.address2 = response.address_2;
          }
        })
        .catch(() => {
          this.$store.commit('showSnackbar', {
            type: 'error',
            message:
            this.text.messages.loadDataError,
          });
        });

      return true;
    },
  },
  computed: {
    text() {
      return translations[state.language];
    },
    requiredAndLength() {
      return this.requiredRules.concat(this.lengthRules);
    },
    requiredRules() {
      return [
        (v) => !!v || this.text.validation.fieldIsRequired,
      ];
    },
    lengthRules() {
      return [
        (v) => ((v && v.length <= 100) || !v) || `${this.text.validation.maxCharactes}: 100`,
      ];
    },
    emailRules() {
      return [
        (v) => !!v || this.text.validation.fieldIsRequired,
        (v) => /.+@.+\..+/.test(v) || this.text.validation.emailNotValid,
      ];
    },
    nipValidator() {
      return [
        (nip) => {
          // Check length
          if (nip == null) return this.text.validation.nipNotCorrect;
          const nipReplaced = nip.replace(/-/g, '');
          if (nipReplaced.length !== 10) return this.text.validation.nipNotCorrect;

          const weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
          let sum = 0;
          const controlNumber = parseInt(nipReplaced.substring(9, 10), 10);
          const weightCount = weight.length;
          for (let i = 0; i < weightCount; i += 1) {
            sum += (parseInt(nipReplaced.substr(i, 1), 10) * weight[i]);
          }
          if (sum % 11 !== controlNumber) {
            return this.text.validation.nipNotCorrect;
          }

          return true;
        },
      ];
    },
  },
};
</script>

<style scoped>

</style>
